import { render } from "./TachographFiles.vue?vue&type=template&id=520d0358&scoped=true&ts=true"
import script from "./TachographFiles.vue?vue&type=script&lang=ts"
export * from "./TachographFiles.vue?vue&type=script&lang=ts"

import "./TachographFiles.vue?vue&type=style&index=0&id=520d0358&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520d0358"]])

export default __exports__